export interface StartTerminal {
    identifier: string | undefined;
    latitude: number;
    longitude: number;
}
